import React from "react";
import { Outlet } from "react-router-dom";
import GoLiveNav from "./components/GoLiveNav";
import "./styles/tailwind.css";
import "./styles/golive.css";

export default function GoLiveLayout() {
  return (
    <div className="gl-layout -mt-6 -mx-8 w-[calc(100%+64px)] flex pt-6 flex-col min-h-full">
      <GoLiveNav />
      <Outlet />
    </div>
  );
}
